import Vue from 'vue'
import scrollLockDirective from '@/directives/scroll-lock'
import permission from '@/directives/permission'

Vue.directive('scroll-lock', scrollLockDirective)
Vue.directive('permission', permission)
